export const searchDataSelector = ({ allData }) => allData;
